import request from './request.js';

/**
 *
 * @param {*} cursor
 * @param {*} query
 * @param brokerage
 */
function getAll(cursor, query, brokerage = null) {
    const isValidQuery = typeof query === 'string' && query.length > 0;
    const queryParams = new URLSearchParams({
        cursor,
        ...(!isValidQuery ? {} : { query: encodeURIComponent(query) }),
        ...(typeof brokerage !== 'string' ? {} : { brokerage: encodeURIComponent(brokerage) })
    });

    const options = {
        endpoint: `/advisors?${ queryParams.toString() }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} advisorID 
 */
function get(advisorID) {
    const options = {
        endpoint: `/advisors/${ advisorID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} body 
 */
function createAdvisor(body) {
    const options = {
        endpoint: '/advisors',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} advisorID 
 * @param {*} body 
 */
function updateAdvisor(advisorID, body) {
    const options = {
        endpoint: `/advisors/${ advisorID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} advisorID 
 * @param {*} body 
 */
function removeAdvisor(advisorID) {
    const options = {
        endpoint: `/advisors/${ advisorID }`,
        method: 'PUT'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} advisorID 
 * @param {*} body 
 */
function createAccount(advisorID, body) {
    const options = {
        endpoint: `/advisors/${ advisorID }/account`,
        method: 'POST',
        advisorID,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function sendForgotPassword(body) {
    const options = {
        endpoint: '/advisors/sendForgotPassword',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param password
 * @param userType
 * @returns {Promise<any>}
 */
function changePassword(userType, password) {
    const options = {
        endpoint: `/${ userType }/password`,
        method: 'PUT',
        body: {
            password
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param institutionNum
 * @param transitNum
 * @returns {Promise<unknown>}
 */
function validateBankingDetails(institutionNum, transitNum) {
    const options = {
        endpoint: '/advisors/branchDetails/validate',
        method: 'POST',
        body: {
            institutionNum,
            transitNum
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param advisorID
 * @param groupNum
 * @param expiry
 * @returns {Promise<unknown>}
 */
function createMarketplaceAffiliateLink(advisorID, groupNum, expiry) {
    const options = {
        endpoint: `/advisors/${ advisorID }/affiliateLink`,
        method: 'POST',
        body: {
            groupNum,
            expiry
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param advisorID
 */
function deleteMarketplaceAffiliateLink(advisorID) {
    const options = {
        endpoint: `/advisors/${ advisorID }/affiliateLink`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    getAll,
    get,
    createAdvisor,
    updateAdvisor,
    removeAdvisor,
    createAccount,
    sendForgotPassword,
    changePassword,
    validateBankingDetails,
    deleteMarketplaceAffiliateLink,
    createMarketplaceAffiliateLink
};